import { useField } from "formik";
import { useState } from "react";

import { EyeIcon, EyeOffIcon } from "../../../assets/icons";
import "../Forms.scss";

/**
 * PasswordInput component
 * @param {{
 *   name: string,
 *   label?: string,
 *   placeholder?: string,
 *   disabled?: boolean,
 *   bottomText?: string,
 *   className?: string,
 *   onChange?: (value: string) => void,
 *   autoFocus?: boolean
 * }} props
 * @returns {JSX.Element} PasswordInput
 */
function PasswordInput({ name, label, placeholder, disabled, bottomText, className, onChange, autoFocus }) {
  const [field, meta] = useField(name);
  const [shown, setShown] = useState(false);

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  }

  return (
    <div className={`input ${className} ${meta.touched && meta.error ? "error" : ""}`}>
      {label ? <label htmlFor={name}>{label}</label> : null}

      <div className="input-field">
        <input
          {...field}
          type={shown ? "text" : "password"}
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          onChange={handleChange}
          autoFocus={autoFocus}
        />

        <button type="button" onClick={() => setShown((prev) => !prev)}>
          {shown ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>

      <div className="meta">
        {meta.touched && meta.error ? <small className="error-msg">{meta.error}</small> : null}
        {bottomText ? <small>{bottomText}</small> : null}
      </div>
    </div>
  );
}

export default PasswordInput;
